import { render, staticRenderFns } from "./StrapiContent.vue?vue&type=template&id=145463fd"
import script from "./StrapiContent.vue?vue&type=script&lang=js"
export * from "./StrapiContent.vue?vue&type=script&lang=js"
import style0 from "./StrapiContent.vue?vue&type=style&index=0&id=145463fd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QInnerLoading,QSpinner,QIcon});
